import LangEnum from '../../../../../../lang/LangEnum';
import { TranslateType } from '../../../../../translation/translationContext.types';
import { ChatStateWithOptionalId } from '../../../../contexts/chat/hooks/useChats/reducer/chatListReducer.types';
import { isPrivateChat, isTopicChat } from '../../../../utils/chat.utils';

type GetBrandStorePrivateInfo = {
  title: string;
  logoUrl?: string;
};

interface FormatBrandStoreChatParams {
  chat: ChatStateWithOptionalId;
  isStore: boolean;
  translate: TranslateType;
}

const getBrandStorePrivateInfo = (
  chat: ChatStateWithOptionalId,
  isStore: boolean,
): GetBrandStorePrivateInfo => {
  if (isStore) {
    return {
      title: chat.brand.commercialName,
      logoUrl: chat.brand.logoUrl,
    };
  }

  return {
    title: chat.stores.length ? chat.stores[0].commercialName : '',
    logoUrl: chat.stores.length ? chat.stores[0].logoUrl : undefined,
  };
};

export const formatBrandStoreChat = ({
  chat,
  isStore,
  translate,
}: FormatBrandStoreChatParams): GetBrandStorePrivateInfo => {
  if (isPrivateChat(chat.type)) {
    return getBrandStorePrivateInfo(chat, isStore);
  }

  if (isTopicChat(chat.type)) {
    return {
      title: translate(LangEnum.GLOBAL_DEVOLUTION_CASE_WITH_CODE, { code: chat.title }),
      logoUrl: chat.brand.logoUrl,
    };
  }

  return {
    title: chat.title,
    logoUrl: chat.brand.logoUrl,
  };
};
